import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

/**
 * Confirm UNLINKING a personal priority from a team priority (My-work polish).
 *
 * Unlinking removes ONLY the private connection — the personal priority itself
 * stays, and any sibling links to OTHER team priorities remain. So this is a
 * NEUTRAL confirmation (never destructive-red; red is reserved for a true
 * delete, which this is not) and the copy explicitly says the personal
 * priority stays private. It is LINK-AGNOSTIC and owner-only: the dialog takes
 * no other-user data, no counts, no member/team activity — its copy is a fixed
 * literal.
 */
export interface UnlinkPersonalPriorityDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isAr: boolean;
  busy?: boolean;
  onConfirm: () => void;
}

export function UnlinkPersonalPriorityDialog({
  open,
  onOpenChange,
  isAr,
  busy,
  onConfirm,
}: UnlinkPersonalPriorityDialogProps) {
  const t = (en: string, ar: string) => (isAr ? ar : en);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="mywork-unlink-confirm">
        <DialogHeader>
          <DialogTitle>
            {t("Unlink this personal priority?", "فك ربط هذه الأولوية الشخصية؟")}
          </DialogTitle>
          <DialogDescription>
            {t(
              "This removes the private connection from this team priority. Your personal priority will stay private.",
              "هذا يزيل الارتباط الخاص من أولوية الفريق هذه. تبقى أولويتك الشخصية خاصة بك.",
            )}
          </DialogDescription>
        </DialogHeader>
        {/* Clear breathing room; the confirm is NEUTRAL (secondary), never
            destructive-red — unlinking is not a delete. */}
        <DialogFooter className="mt-4" data-testid="mywork-unlink-footer">
          <Button
            variant="ghost"
            onClick={() => onOpenChange(false)}
            data-testid="mywork-unlink-cancel"
          >
            {t("Cancel", "إلغاء")}
          </Button>
          <Button
            variant="secondary"
            disabled={busy}
            onClick={onConfirm}
            data-testid="mywork-unlink-confirm-btn"
          >
            {t("Unlink", "فك الربط")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
